import { render, staticRenderFns } from "./OMSRuleLogs.vue?vue&type=template&id=372d790e"
import script from "./OMSRuleLogs.vue?vue&type=script&lang=js"
export * from "./OMSRuleLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports